import React from 'react';
import { Tag } from '@wix/design-system';
import { BlockSmall } from '@wix/wix-ui-icons-common';

export interface DragAndDropDisabledMessageProps {
  message: string;
}

export function DragAndDropDisabledMessage(
  props: DragAndDropDisabledMessageProps,
) {
  const { message } = props;

  return (
    <Tag
      id="nested-table-dnd-disabled-message"
      dataHook="nested-table-dnd-disabled-message"
      theme="light"
      thumb={<BlockSmall />}
      removable={false}
    >
      {message}
    </Tag>
  );
}
